export default "__VITE_ASSET__C8h7HqGA__"